module.exports = __webpack_public_path__ + "static/img/image_solutions_intellgent_04.56d3a4c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_intellgent_04.png
// module id = Zbmt
// module chunks = 10